// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1kvq4","title":"ClientInsurance_title__DdZlS","itemText":"ClientInsurance_itemText__fjafG"};